import { API_CONFIG, apiUtils } from '../config.js';

export const subscriptionApi = {
  // Get dashboard summary (balance, usage, expiry)
  getStatus: async () => {
    const url = `${API_CONFIG.BASE_URL}/subscription/status`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get current plan details
  getMySubscription: async () => {
    const url = `${API_CONFIG.BASE_URL}/subscription/my-subscription`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get transaction history
  getHistory: async () => {
    const url = `${API_CONFIG.BASE_URL}/subscription/history`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get available plans
  getPlans: async () => {
    const url = `${API_CONFIG.BASE_URL}/subscription/plans`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Upgrade organization to a new tier
  upgradePlan: async (planId) => {
    const url = `${API_CONFIG.BASE_URL}/subscription/upgrade`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify({ planId }),
    });
  },

  // Buy extra messages
  topUp: async (messageCount) => {
    const url = `${API_CONFIG.BASE_URL}/subscription/top-up`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify({ messageCount }),
    });
  },
};

export default subscriptionApi;
